(function basicpageScript($, Drupal) {
  Drupal.behaviors.basicpage = {
    attach(context) {
    },
  };
}(jQuery, Drupal));
